/**
 * Загрузочный экран мини-аппа (17.14).
 *
 * Показывается ровно столько, сколько идёт первый запрос. Это первое, что
 * видит человек, поэтому здесь не спиннер, а спокойная брендовая заставка.
 */

import { BrandMark } from '@/shared/ui/BrandMark'
import { Icon } from '@/shared/ui/Icon'
import { TimeSky } from '@/shared/ui/decor'

export function Splash({ hint }: { hint?: string }) {
  return (
    <div className="relative flex min-h-full flex-col items-center justify-center px-8 text-center">
      <TimeSky className="h-full opacity-70" />

      <div className="relative flex flex-col items-center">
        {/* Знак появляется, потом дышит: заставка живёт ровно столько, сколько
            идёт первый запрос, и неподвижная картинка в эти секунды читается
            как зависание. Без наклейки и поворота — знак не вращают (docs/brand). */}
        <div aria-hidden className="pop mb-6">
          <BrandMark size={88} style={{ animation: 'breathe 3.2s ease-in-out infinite 460ms' }} />
        </div>
        {/* Название здесь — часть знака, а не заголовок экрана: набрано как
            надпись из брендбука (Golos 700, трекинг −40), а не шрифтом Alice. */}
        <h1 className="enter text-hero font-sans leading-none font-bold tracking-[-0.04em]">
          ЯНяня
        </h1>
        <p
          className="font-hand text-text-muted enter mt-2 text-title leading-tight"
          style={{ animationDelay: '160ms' }}
        >
          один день — на двоих
        </p>
      </div>
      {hint && <p className="text-text-muted relative mt-8 text-caption">{hint}</p>}
    </div>
  )
}

/** Мини-апп открыли вне Telegram — объясняем, а не показываем белый экран. */
export function OutsideTelegram() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center px-8 text-center">
      <div
        aria-hidden
        className="sticker bg-surface pop mb-5 flex size-[68px] rotate-[4deg] items-center justify-center rounded-[var(--radius-card)]"
      >
        <Icon name="telegram" size={30} />
      </div>
      <h1 className="font-display text-title leading-tight">Откройте из Telegram</h1>
      <p className="text-text-muted mt-2 max-w-[300px] text-note leading-snug">
        ЯНяня работает внутри Telegram: так приложение знает, кто вы, и никому не нужен
        отдельный пароль.
      </p>
      <a
        href="https://t.me/yanyanaru_bot"
        className="text-accent tap-target mt-4 inline-flex items-center px-4 font-medium underline underline-offset-4"
      >
        Открыть бота
      </a>
    </div>
  )
}
